import { Tables } from "@/lib/supabase/supabase_types_override";
import { QuestionNotInTemplateChange, QuestionMissingChange } from "@/features/survey_sync/types/syncCheckResult";

export const checkIfQuestionNotInTemplate = (
  question: Tables<"question">,
  templateQuestions: Tables<"survey_bank_question_bank">[]
): QuestionNotInTemplateChange | false => {
  const notInTemplate = !templateQuestions.some(
    (tq) => tq.id === question.survey_bank_question_bank_ref_id
  );

  if (notInTemplate) {
    return {
      type: "QUESTION_NOT_IN_TEMPLATE",
      context: {
        question: question,
      },
    };
  }

  return false;
};

export const checkForMissingQuestionsInInstance = (
  surveyQuestions: Tables<"question">[],
  templateQuestions: Tables<"survey_bank_question_bank">[]
): QuestionMissingChange[] => {
  const surveyQuestionRefs = new Set(
    surveyQuestions
      .map(sq => sq.survey_bank_question_bank_ref_id)
      .filter(Boolean)
  );

  const missingQuestions: QuestionMissingChange[] = [];

  templateQuestions.forEach(templateQuestion => {
    if (!surveyQuestionRefs.has(templateQuestion.id)) {
      missingQuestions.push({
        type: "QUESTION_IS_MISSING_IN_INSTANCE",
        context: {
          templateQuestion: templateQuestion,
        },
      });
    }
  });

  return missingQuestions;
};